import ChevronRight from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { Button } from '@simplywallst/ui-core';
import Tooltip from '@/components/Tooltip';

import { PrimaryNarrativeIcon } from './PrimaryNarrativeIcon';

type Props = {
  tickerSymbol: string;
};

export const EmptyState = ({ tickerSymbol }: Props) => {
  return (
    <div className="grid gap-2 h-x12">
      <div className="grid grid-cols-[auto_auto] justify-start items-center gap-x1">
        <div className="grid gap-2 grid-cols-[24px_max-content] items-center">
          <PrimaryNarrativeIcon type="dcf" />
          <div>
            <span className="m-0 text-xs text-solid">N/A</span>
            <span className="sr-only">author fair value</span>
          </div>
        </div>
        <div>
          <span className="text-tiny text-softer">Yesterday</span>
          <span className="sr-only">author updated this narrative</span>
        </div>
      </div>
      <div className="grid grid-cols-[auto_auto] justify-between items-start gap-x2">
        <h4 className="m-0 text-xs text-soft line-clamp-2">
          Insufficient data to calculate {tickerSymbol}'s fair value for
          valuation analysis.
        </h4>
        <Tooltip
          placement="top-end"
          light
          title={
            <p className="m-0 line-clamp-2 text-tiny text-noir w-48">
              You can select a narrative from community or create one yourself.
            </p>
          }
        >
          <Button styleType="gentle" alignIcon="right">
            Select
            <ChevronRight />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
